import { state } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export const initialState = () => ({
  isEditing: false,
  coverageToEditId: null,
  areas: [],
  ...state
})
